export const SORT_TYPES = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const HEADER_HEIGHT = 124;
export const SIDEBAR_WIDTH = 220;
export const BOTTOM_PADDING = 24;
export const CONTENT_WIDTH = 1240;
export const CONTENT_VERTICAL_PADDING = 20;
export const CONTENT_INNER_WIDTH = CONTENT_WIDTH - CONTENT_VERTICAL_PADDING * 2;
export const RIGHT_SIDEBAR_WIDTH = 362;
export const SCROLLBAR_WIDTH = 18;



// WEBPACK FOOTER //
// ./src/common/constants.js